module.exports = __webpack_public_path__ + "img/partner8.9267f69f.png";